import {Observable, Subject} from "rxjs";

export class SortGroup {

  private orders: {
    [column: string]: { order: SortOrder, order$: Subject<SortOrder> }
  };

  private sortBy?: SortBy = null;
  readonly sortBy$ = new Subject<SortBy>();

  constructor(
    ...columns: Array<string>
  ) {
    this.orders = {};
    for (let col of columns) {
      this.orders[col] = {order: null, order$: new Subject()};
    }
  }

  click(column: string) {
    let oldOrder = this.orders[column].order;
    let newOrder: SortOrder;
    if (!oldOrder) {
      newOrder = SortOrder.ASC;
    } else if (oldOrder === SortOrder.ASC) {
      newOrder = SortOrder.DESC;
    } else if (oldOrder === SortOrder.DESC) {
      newOrder = null;
    } else {
      throw Error("Unexpected sort order: " + oldOrder);
    }

    for (let col of Object.keys(this.orders)) {
      if (col === column) {
        this.orders[col].order = newOrder;
      } else {
        this.orders[col].order = null;
      }

      this.orders[col].order$.next(this.orders[col].order);
    }

    this.sortBy = newOrder ? {column, order: newOrder} : null;
    this.emit();
  }

  emit() {
    this.sortBy$.next(this.sortBy);
  }

  getOrder(column: string): Observable<SortOrder> {
    return this.orders[column].order$;
  }
}

export interface SortBy {
  column: string,
  order: SortOrder
}

export enum SortOrder { ASC = "ASC", DESC = "DESC" }

export function getComparator(sortBy: SortBy, ...accessors: Array<FieldAccessor>): (a: any, b: any) => number {
  let accessor = accessors.find(a => a.column === sortBy.column);
  let getter = (accessor && accessor.getter) || (obj => obj[sortBy.column]);
  return (a, b) => {
    let aVal = getter(a);
    let bVal = getter(b);
    if (sortBy.order === SortOrder.ASC) {
      return compare(aVal, bVal);
    } else if (sortBy.order === SortOrder.DESC) {
      return compare(bVal, aVal);
    } else {
      throw Error("Unexpected sort order: " + sortBy.order);
    }
  }
}

export type FieldAccessor = { column: string, getter: (object) => any }

function compare(a: any, b: any): number {
  if (typeof a === "number" && typeof b === "number") {
    return a - b;
  } else if (typeof a === "string" && typeof b === "string") {
    return a.localeCompare(b);
  } else {
    console.log("Unsupported compare operation", a, b);
    throw Error("Unsupported compare operation");
  }
}
